import styled from "styled-components";
import { device } from "../../themes/Breakpoints";

export const BadgesWrap = styled.div`
  img {
    display: block;
    width: 100%;
    object-fit: cover;
    height: auto;
    max-width: ${(props) => (props.width ? props.width : "78px")};
  }
  @media only screen and (max-width: 1249px) {
    img {
      max-width: ${(props) => (props.width ? props.width : "68px")};
    }
  }
  @media ${device.mobileL} {
    img {
      max-width: ${(props) => (props.width ? props.width : "60px")};
    }
  }
  @media ${device.mobileM} {
    img {
      max-width: ${(props) => (props.width ? props.width : "50px")};
    }
  }
  @media ${device.mobileS} {
    img {
      max-width: ${(props) => (props.width ? props.width : "50px")};
    }
  }
`;